import { createContext, useContext, useEffect, useState } from "react";
import { getJobs } from "../httpService";
import { getSnapshotValue, hasSnapshotValue } from "../snapshot.js";
import { UserContext } from "./UserContext";

const JobsContext = createContext({ jobs: [], loading: true, error: null });

const JobsContextProvider = (props) => {
  const { locale } = useContext(UserContext);
  const [jobs, setJobs] = useState(() => getSnapshotValue("jobs", []));
  const [loading, setLoading] = useState(() => !hasSnapshotValue("jobs"));
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getJobs(locale)
      .then(setJobs)
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
  }, [locale]);

  return <JobsContext.Provider value={{ jobs, loading, error }} {...props} />;
};

export { JobsContextProvider, JobsContext };
